
import { getBrandDetailsFromBrandJson } from './share';

export async function getExitPopupTimerValue(): Promise<number> {
    const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;

    if (!conceptCode) {
        return 10 * 1000;
    }

    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    const exit_popup_timer_value = (brandData?.exit_popup_timer_value ?? 10);
    return exit_popup_timer_value * 1000;
}


